import { render, staticRenderFns } from "./EmailChangeContactButtonTable.vue?vue&type=template&id=235a1dc0"
import script from "./EmailChangeContactButtonTable.vue?vue&type=script&lang=js"
export * from "./EmailChangeContactButtonTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports